<template>
  <!-- 
    Только для разработчиков, показывает границы и название компонента, в котором находится
    Используется для отладки и разработки компонентов, чтобы легче было находить ошибки
    Надо разместить в самом начале корневого компонента
    * Пример использования: 
    <template>
      <Col>
        <ComponentBound />
        ...остальные элементы...
      </Col> 
    </template>
  -->
  <div v-if="$isDev && show" class="el-overlay">
    <span class="text-12 text-mid-grey abs" style="top:2px; right:4px">{{ parentName }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  components: {

  },

  props: {

  },

  data: () => ({
  }),

  computed: {
    ...mapState('common', {
      show: s => s.showDevInfo
    }),
    parentName() {
      const { $options, $vnode } = this.$parent.$parent;
      return $options._componentTag || $vnode.tag.split('-').pop() || 'Unknown Component';
    },
  },
  
  methods: {

  },

}
</script>

<style lang="scss">

</style>